<script>
  import {get} from 'svelte/store';
  import {lang$} from '@/store/lang';
  import {loadBanner} from './streams';

  const {banner$} = loadBanner({itemKey:'banner', location: 22, device: 'WEB', lang: get(lang$) || 'en'});

  let bannerInfo = {};
  $: bannerInfo = $banner$?.detail || {}
</script>

<style lang="scss">
  .login-banner-con{
    width: 400px;
    padding: 60px 0;
    //text-align: center;
    .image{
      width: 400px;
      min-height: 500px;
    }
    .sub{
      color: #B0B2B8
    }
  }
</style>

<div class="df jcc">
  <div class="login-banner-con">
    <div class="f32 fw3 lh48 TW">{bannerInfo.title || ''}</div>
    <div class="f16 pv12 lh24 sub">{bannerInfo.description || ''}</div>
    <a class="df aic image" href={bannerInfo.webLink || 'javascript: void(0);'} target="_blank">
      <img width="400" src={bannerInfo.webimg} alt={bannerInfo.webBannerAlt}/>
    </a>
  </div>
</div>
